var e = {
	requireAuth: {
		default: "Sign in to view this page",
		signIn: "Sign in",
		workspace: "Sign in to set up your workspace",
		booking: "Sign in to view your booking",
		messages: "Sign in to view your messages",
		favorites: "Sign in to view your favorites",
		account: "Sign in to view your account",
		checkout: "Sign in to continue to checkout",
		trips: "Sign in to view your trips",
		notifications: "Sign in to view your notifications",
		support: "Sign in to contact support and track your requests",
		creator: "Sign in to open your Creator Portal"
	},
	oauth: {
		continueWith: "Continue with {{provider}}",
		orContinueWithEmail: "or continue with email",
		signInFailedTitle: "Sign-in failed",
		signInFailed: "Could not sign in. Please try again."
	},
	connectedAccounts: {
		title: "Connected accounts",
		description: "Link accounts to sign in faster.",
		connect: "Connect",
		disconnect: "Disconnect",
		confirm: "Confirm",
		removing: "Removing…",
		connecting: "Connecting…",
		connectedTitle: "Account connected",
		connectFailed: "Could not connect account",
		disconnectedTitle: "Account disconnected",
		disconnectFailed: "Could not disconnect"
	},
	login: {
		title: "Welcome Back",
		description: {
			default: "Sign in to manage your properties",
			otp: "Enter the code sent to {{email}}",
			password: "Enter your password for {{email}}",
			password_phone: "Enter your password for {{phone}}",
			mfa: "Enter your authentication code",
			phone_otp: "Enter the code sent to {{phone}}",
			passkey: "Sign in with your passkey",
			passkey_offer: "One more thing, if you want it"
		},
		noAccount: "Don't have an account?",
		signUp: "Sign up"
	},
	restore: {
		description: "This account is scheduled for deletion",
		scheduled: "Your account is scheduled for permanent deletion on {{date}}.",
		scheduledNoDate: "Your account is scheduled for permanent deletion.",
		explainer: "Restoring cancels the deletion and signs you in — everything is exactly as you left it.",
		restore: "Restore my account",
		restoring: "Restoring…",
		keepDeleted: "Keep it deleted",
		expiredTitle: "That restore link expired",
		expiredBody: "For security, restoring is only possible right after signing in. Sign in again to get a fresh chance.",
		signInAgain: "Sign in again",
		errorTitle: "Couldn't restore your account"
	},
	register: {
		title: "Create Account",
		completeTitle: "Complete your profile",
		description: {
			email: "Enter your email address to get started",
			verify: "We sent a 6-digit code to {{email}}",
			complete: "Welcome {{email}}! Please set your name and password.",
			verifyPhone: "We sent a 6-digit code to {{phone}}",
			completePhone: "Almost done — tell us your name.",
			passkeyOffer: "One more thing, if you want it"
		},
		haveAccount: "Already have an account?",
		signIn: "Sign in",
		referralOffer: "Your offer from {{name}}"
	},
	loginEmail: {
		emailLabel: "Email Address",
		emailPlaceholder: "john@example.com",
		submit: "Continue with Email",
		submitting: "Checking...",
		errorTitle: "Error",
		requestFailed: "Failed to process login request"
	},
	loginPassword: {
		label: "Password",
		placeholder: "Enter your password",
		submit: "Sign In",
		submitting: "Signing In...",
		errorTitle: "Error",
		invalidCredentials: "Invalid credentials. Please try again.",
		useCode: "Send me a code instead",
		validation: { required: "Password is required" }
	},
	forgotPassword: {
		link: "Forgot password?",
		description: {
			phone: "We'll send a code to the phone number on your account.",
			code: "Enter the code we sent to {{phone}}",
			password: "Choose a new password. Your other devices will be signed out."
		},
		phoneLabel: "Phone number",
		phoneHint: "Your account needs a phone number to reset its password this way.",
		send: "Send code",
		sending: "Sending…",
		sendFailed: "We couldn't send a code. Please try again.",
		verify: "Continue",
		verifying: "Verifying…",
		submit: "Reset password",
		saving: "Saving…",
		doneTitle: "Your password has been reset",
		errorTitle: "Couldn't reset your password",
		expired: "This reset has expired. Please start again.",
		restart: "Start again"
	},
	loginOtp: {
		label: "Verification Code",
		placeholder: "Enter code",
		submit: "Sign In",
		submitting: "Verifying...",
		errorTitle: "Error",
		invalidCode: "Invalid code. Please try again."
	},
	loginMfa: {
		recoveryLabel: "Recovery code",
		recoveryPlaceholder: "XXXXX-XXXXX",
		codeLabel: "Authentication code",
		codeHint: "Enter the 6-digit code from your authenticator app.",
		rememberDevice: "Remember this device for 30 days",
		submit: "Verify",
		submitting: "Verifying...",
		useAuthenticator: "Use your authenticator app instead",
		useRecovery: "Use a recovery code",
		errorTitle: "Error",
		invalidCode: "Invalid code. Please try again.",
		validation: { recoveryRequired: "Enter your recovery code" }
	},
	registerEmail: {
		emailLabel: "Email Address",
		emailPlaceholder: "john@example.com",
		submit: "Continue",
		submitting: "Sending Code...",
		errorTitle: "Error",
		requestFailed: "Failed to request OTP. Please try again.",
		validation: {
			emailRequired: "Email is required",
			emailInvalid: "Enter a valid email address"
		}
	},
	registerVerify: {
		submit: "Verify Email",
		submitting: "Verifying...",
		resend: "Resend Code",
		resendCountdown: "Resend Code in {{seconds}}s",
		codeSentTitle: "Code sent",
		codeSent: "A new 6-digit code has been sent to {{email}}",
		resendFailed: "Failed to resend code.",
		invalidCode: "Invalid or expired OTP code."
	},
	completeProfile: {
		firstNameLabel: "First Name",
		firstNamePlaceholder: "Jane",
		lastNameLabel: "Last Name",
		lastNamePlaceholder: "Doe",
		passwordLabel: "Password",
		passwordPlaceholder: "Create a strong password",
		submit: "Complete Registration",
		submitting: "Saving...",
		welcomeTitle: "Welcome!",
		welcomeBody: "Your account has been fully set up.",
		completeFailed: "Failed to complete registration.",
		inviteCodeToggle: "Have an invite code?",
		inviteCodeLabel: "Invite code",
		inviteCodePlaceholder: "Enter your invite code",
		inviteCodeHint: "Optional — a wrong code never blocks your signup.",
		validation: {
			firstNameRequired: "First name is required",
			lastNameRequired: "Last name is required",
			passwordMinLength: "Password must be at least 8 characters",
			inviteCodeTooLong: "Invite codes are at most 20 characters"
		}
	},
	inviteLanding: {
		loading: "Checking your invite…",
		invitedBy: "{{name}} invited you to Maat",
		subtitle: "Create your free account to claim this offer and book unique stays.",
		createAccount: "Create account",
		exploreStays: "Explore stays",
		getCode: "Get your invite code",
		codeTitle: "Your invite code",
		codeHint: "It's applied automatically when you sign up here — or enter it manually in the app.",
		invalidTitle: "This invite link isn't active",
		invalidBody: "The link may have expired or been turned off. You can still create a free account and browse stays.",
		browseStays: "Browse stays",
		successTitle: "Welcome to Maat!",
		successBody: "Your account is ready, and your discount is on its way to your account — it will appear in My coupons in a few seconds.",
		viewCoupons: "View my coupons",
		startExploring: "Start exploring"
	},
	passwordModal: {
		changeTitle: "Change password",
		setTitle: "Set a password",
		changeDescription: "Enter your current password and choose a new one.",
		setDescription: "Add a password so you can also sign in with your email.",
		currentLabel: "Current password",
		newLabel: "New password",
		confirmLabel: "Confirm password",
		saving: "Saving…",
		changedTitle: "Password changed",
		setSuccessTitle: "Password set",
		changeFailedTitle: "Failed to change password",
		setFailedTitle: "Failed to set password",
		validation: {
			currentRequired: "Enter your current password.",
			mismatch: "Passwords do not match."
		}
	},
	twoFactor: {
		setup: {
			title: "Set up two-factor",
			description: "Scan the QR with your authenticator app, then enter the 6-digit code.",
			qrAlt: "Authenticator QR code",
			loading: "Loading…",
			manualKey: "Or enter this key manually: {{secret}}",
			codeLabel: "6-digit code",
			submit: "Verify & enable",
			submitting: "Verifying…"
		},
		recoveryCodes: {
			title: "Save your recovery codes",
			description: "Store these somewhere safe. Each can be used once if you lose your authenticator.",
			done: "Done"
		},
		disable: {
			title: "Disable two-factor",
			description: "Enter a code from your authenticator (or a recovery code) to turn it off.",
			codeLabel: "Authentication code",
			submit: "Disable two-factor",
			submitting: "Disabling…"
		},
		startFailedTitle: "Could not start setup",
		invalidCodeTitle: "Invalid code",
		disabledTitle: "Two-factor disabled"
	},
	admin: {
		akedlyInbox: {
			title: "Akedly inbox",
			subtitle: "Every OTP/passkey callback Akedly has posted, and what became of it. Envelopes only — a parked body still carries the caller's phone number, the one piece of PII phone_auth_transactions deliberately never stores.",
			payloadNotice: "The stored body is never shown here. What a quarantined delivery could not tell us is in its reason. Nothing is ever minted from a callback — the drain only reconciles a transaction we already sent.",
			stats: {
				quarantined: "Quarantined",
				quarantinedHint: "Parked for a human. A retry can never resolve these.",
				retrying: "Retrying",
				retryingHint: "Failed on something transient.",
				pending: "Awaiting the drain",
				pendingHint: "Captured, waiting for the drain. Seconds, normally.",
				processed: "Processed",
				processedHint: "Reconciled against a transaction. Most of this table.",
				oldest: "Oldest unresolved",
				oldestNone: "Nothing waiting",
				dlqDepth: "Dead-lettered",
				dlqDepthHint: "Messages parked on the broker queue.",
				dlqUnavailable: "Unknown — the service could not be reached."
			},
			redrive: {
				action: "Redrive dead-lettered",
				running: "Redriving…",
				confirmTitle: "Redrive dead-lettered deliveries?",
				confirmBody: "Every message parked on main.akedly_webhook_inbox is republished for the drain to try again. A callback that already reconciled is a no-op.",
				confirm: "Redrive",
				done_one: "Redrove {{count}} message.",
				done_other: "Redrove {{count}} messages.",
				failed: "Redrive failed.",
				nothing: "Nothing is parked on the broker queue."
			},
			empty: {
				title: "Nothing has arrived yet",
				body: "Akedly has not posted a callback to this environment. That is expected until a send has gone out and been answered."
			},
			filtered: {
				title: "Nothing matched",
				body: "No captured delivery matches these filters."
			},
			columns: {
				transaction: "Transaction",
				event: "Event",
				method: "Method",
				test: "Test",
				testYes: "Yes",
				status: "Status",
				retries: "Retries",
				reason: "Reason",
				received: "Received"
			},
			filters: {
				allStatuses: "All statuses",
				allEventTypes: "All event types",
				allDeliveries: "All deliveries",
				testOnly: "Test only",
				realOnly: "Real only",
				allChannels: "All channels"
			},
			eventType: {
				result: "Verification result",
				channelsResolved: "Channel resolved",
				channelsUpdated: "Channel updated"
			},
			status: {
				pending: "Pending",
				processed: "Processed",
				failed_retryable: "Retrying",
				quarantined: "Quarantined"
			},
			noReason: "—",
			transactionFilter: "Filtered to transaction {{id}}",
			clearTransactionFilter: "Clear",
			channel: {
				whatsapp: "WhatsApp",
				sms: "SMS",
				telegram: "Telegram"
			},
			drawer: {
				title: "Callback delivery",
				testBadge: "Test delivery",
				viewOnAkedly: "View on Akedly",
				loadError: "Could not load this delivery",
				loadErrorBody: "The request failed — this says nothing about the delivery itself. Close the drawer and open it again to retry.",
				stats: {
					received: "Received",
					settled: "Settled",
					retries: "Retries"
				},
				envelope: {
					title: "Delivery",
					event: "Event",
					method: "Method",
					test: "Test delivery",
					testYes: "Yes",
					testNo: "No",
					received: "Received",
					processedAt: "Processed",
					quarantinedAt: "Quarantined",
					reason: "Quarantine reason",
					lastError: "Last drain error"
				},
				vendor: {
					title: "What Akedly sent",
					subtitle: "Named fields read from the stored body on the server. The body itself is never shown — it can still hold the caller’s phone number.",
					status: "Vendor status",
					updateDate: "Updated (vendor clock)",
					verificationDate: "Verified (vendor clock)",
					channels: "Channels",
					reason: "Channel reason",
					timestamp: "Event time (vendor clock)",
					eventId: "Event ID",
					eventVersion: "Event version",
					none: {
						title: "Nothing readable",
						body: "This body carried none of these fields. The quarantine reason says why it was parked."
					}
				},
				transaction: {
					title: "Linked transaction",
					phone: "Phone",
					status: "Status",
					purpose: "Purpose",
					kind: "Kind",
					client: "Client",
					channels: "Channels",
					channelReason: "Channel reason",
					failureCode: "Failure code",
					vendorCode: "Vendor code",
					callbackStatus: "Callback status",
					sent: "Sent",
					verified: "Verified",
					none: {
						title: "No transaction of ours",
						body: "No sign-in attempt in this environment carries this vendor ID — a dashboard test, or a send from another environment."
					}
				}
			}
		},
		phoneAuth: {
			title: "Phone auth",
			subtitle: "Every phone sign-in and passkey attempt ever made — the refused and the never-sent included — its live status, its failure code, provider health, and a phone lookup that never stores the number.",
			window: {
				"24h": "Last 24 hours",
				"7d": "Last 7 days"
			},
			stats: {
				sends: "Sends",
				sendsHint: "of {{total}} attempts total",
				verifiedRate: "Verified rate",
				verifiedRateNone: "No sends yet",
				failed: "Failed",
				topFailure: "Top: {{code}} ({{count}})",
				notSent: "Not sent",
				notSentHint: "The platform refused before a message existed.",
				rateLimited: "Rate limited",
				callbacksOutstanding: "Callbacks outstanding",
				callbacksOutstandingHint: "Sent over 10 minutes ago with no callback yet.",
				channelsUpdated: "Channels re-resolved",
				channelsUpdatedHint: "Akedly moved a code to another channel after the first attempt."
			},
			health: {
				title: "Provider health",
				notConfigured: "Not configured",
				state: {
					ok: "OK",
					degraded: "Degraded",
					down: "Down"
				},
				lastSuccess: "Last success",
				lastError: "Last error",
				never: "Never",
				consecutiveFailures: "Consecutive failures",
				capabilities: "Capabilities",
				proofOfWork: "Proof of work",
				passkeys: "Passkeys",
				callbackToken: "Callback token",
				set: "Set",
				unset: "Unset",
				phoneLookup: "Phone lookup",
				available: "Available",
				unavailable: "Unavailable",
				queueDepth: "Callback queue depth",
				queueDepthUnknown: "Unknown — the service could not be reached."
			},
			columns: {
				phone: "Phone",
				kind: "Kind",
				purpose: "Purpose",
				client: "Client",
				status: "Status",
				failureCode: "Failure code",
				channels: "Channels",
				sentAt: "Sent",
				settledAt: "Verified / failed",
				callback: "Callback",
				latency: "Latency (send / verify)"
			},
			status: {
				not_sent: "Not sent",
				sent: "Sent",
				verified: "Verified",
				failed: "Failed",
				expired: "Expired",
				reconciled: "Reconciled"
			},
			kind: {
				otp: "OTP",
				passkey: "Passkey"
			},
			purpose: {
				PHONE_LOGIN: "Phone login",
				PHONE_REGISTRATION: "Phone registration",
				PHONE_LINK: "Link phone",
				PASSKEY_ENROLLMENT: "Passkey enrollment",
				PHONE_ACCOUNT_DELETION: "Account deletion re-auth",
				PHONE_PASSWORD_RESET: "Password reset"
			},
			client: {
				web: "Web",
				native: "Native"
			},
			filters: {
				allStatuses: "All statuses",
				allPurposes: "All purposes",
				allKinds: "All kinds",
				allClients: "All clients",
				allDeliveries: "All sends",
				testOnly: "Test only",
				realOnly: "Real only",
				failureCodePlaceholder: "Failure code…",
				fromLabel: "From",
				toLabel: "To",
				userIdPlaceholder: "User ID…",
				moreFilters: "More filters"
			},
			lookup: {
				placeholder: "Look up by phone number…",
				unavailable: "Phone lookup is off: PHONE_AUTH_LOOKUP_PEPPER is unset."
			},
			noCallback: "No callback yet",
			noValue: "—",
			empty: {
				title: "Nothing sent yet",
				body: "No phone sign-in or passkey attempt has been made in this environment yet."
			},
			filtered: {
				title: "Nothing matched",
				body: "No attempt matches these filters."
			},
			drawer: {
				title: "Attempt {{phone}}",
				timelineTitle: "Timeline",
				step: {
					not_sent: "Not sent",
					sent: "Sent",
					verified: "Verified",
					failed: "Failed",
					expired: "Expired",
					channels_resolved: "Channel resolved",
					callback_received: "Callback received"
				},
				channelsTitle: "Channels",
				channelsResolvedAt: "{{reason}} · resolved {{at}}",
				channelsFromSend: "Reported by the send call; Akedly has not confirmed a channel yet.",
				inboxTitle: "Linked callback",
				inboxNone: "No callback has arrived for this attempt yet.",
				viewInInbox: "View in Akedly inbox"
			}
		}
	},
	loginIdentifier: {
		emailTab: "Email",
		phoneTab: "Phone",
		phoneLabel: "Phone number",
		phoneHint: "We send a code by WhatsApp or SMS.",
		continue: "Continue",
		submitting: "Checking…"
	},
	loginPhoneOtp: {
		title: "Enter your code",
		description: "We sent a 6-digit code to {{phone}}",
		sentVia: "Sent via {{channels}}",
		sent: "If that number has an account, the code is on its way.",
		submit: "Sign in",
		submitting: "Verifying…",
		resend: "Send a new code",
		resendIn: "Send a new code in {{seconds}}s",
		resending: "Sending…",
		useDifferentNumber: "Use a different number",
		errorTitle: "Couldn't sign you in"
	},
	loginPasskey: {
		title: "Use your passkey",
		description: "Confirm with Face ID, Touch ID or your device PIN.",
		continue: "Continue with passkey",
		continuing: "Waiting for your device…",
		useCode: "Use a code instead",
		unsupported: "This browser can't use passkeys, so we sent you a code instead.",
		cancelled: "That was cancelled. Try again, or use a code instead.",
		popupBlocked: "Your browser blocked the passkey window. Allow pop-ups for this site, or use a code instead.",
		failed: "We couldn't confirm that passkey. Try again, or use a code instead.",
		noProof: "Your device confirmed — finishing up.",
		reconciling: "Confirming with your device…",
		unconfirmed: "We couldn't confirm the passkey, so here is a code instead.",
		descriptionNative: "Confirm with Face ID, Touch ID or your device passcode.",
		unsupportedNative: "This device can't use passkeys, so we sent you a code instead."
	},
	registerPhone: {
		phoneLabel: "Phone number",
		phoneHint: "We send a code by WhatsApp or SMS.",
		submit: "Continue",
		submitting: "Sending code…",
		errorTitle: "Couldn't send your code",
		alreadyRegistered: "That number already has an account.",
		signInInstead: "Sign in instead",
		verifyDescription: "We sent a 6-digit code to {{phone}}",
		completeDescription: "Almost done — tell us your name.",
		passwordOptionalLabel: "Password (optional)",
		passwordOptionalHint: "You can sign in with a code, so a password is up to you.",
		enrolledConfirmation: "Your passkey is ready — next time, one tap signs you in."
	},
	passkeyOffer: {
		title: "Sign in faster next time",
		description: "Add a passkey and Face ID, Touch ID or your device PIN signs you in — no codes.",
		enable: "Add a passkey",
		enabling: "Waiting for your device…",
		skip: "Not now",
		enrolled: "Passkey added.",
		failed: "That didn't finish. You can add a passkey later from Sign-in methods.",
		laterHint: "You can always add one later from Sign-in methods."
	},
	phoneAuthError: {
		rate_limited: "Too many attempts. Try again in {{minutes}} min.",
		rate_limited_soon: "Too many attempts. Try again in a moment.",
		expired: "That code expired. Send a new one.",
		max_attempts: "Too many wrong codes. Send a new one.",
		unavailable: "Phone sign-in isn't available right now. Try again shortly.",
		pow_stale: "That took too long. Try again.",
		invalid_code: "That code doesn't match. Check it and try again.",
		already_verified: "That code was already used. Send a new one.",
		invalid_phone: "That doesn't look like a number we can reach.",
		phone_required: "Add a phone number first.",
		phone_already_registered: "That number already has an account.",
		no_passkey: "There is no passkey on this account any more.",
		passkeys_unavailable: "Passkeys aren't available right now.",
		passkey_failed: "We couldn't confirm that passkey.",
		attempt_expired: "That took too long. Start again.",
		generic: "Something went wrong. Try again."
	}
};
//#endregion
export { e as default };
